<div
  class="d-flex offer-list justify-content-center"
  [class.offer-list--vertical]="computedVariant === 'accordion'"
  [class.offer-list--has-floating-label]="listContainsHighlights()"
  wlAutomationId="commodity-best-offer-list-offers"
  [wlTrackStep]="{
    type: AnalyticsActionTypes.LAST_STEP,
    toolName: 'Keuzehulp',
    stepName: 'laststep',
    step: nrOfQuestions + 1,
    extraProperties: { result: answers() },
  }"
  wlCSCapture
>
  @if (isMijnConsumentEssent()) {
    @if (offersExist()) {
      @if (matchingOffer(); as matchingOffer) {
        <div>
          <div
            class="bg-brand text-white font-bold p-2"
            wlAutomationId="best-offer-label"
          >
            {{ content()?.questionnaireBestChoiceTitle }}
          </div>
          <div class="max-h-[450px]">
            @if (isHighestMatch('variable')) {
              <wl-variable-offer-card
                [isBestChoice]="true"
                [title]="content()?.questionnaireVariableCardTitle"
                [description]="content()?.questionnaireVariableCardDescription"
                [buttonTitle]="content()?.questionnaireVariableCardSubmitTitle"
                [explanationButtonTitle]="
                  content()?.questionnaireExplanationButtonTitle
                "
                (showExplanation)="showExplanation.emit('variable')"
                (selectOffer)="selectVariableOffer.emit()"
              />
            } @else {
              <!--   we cast using $any() because we know due to the above that it is not the alternate type   -->
              <essent-consumer-retention-minimal-commodity-offer
                [offer]="$any(matchingOffer)"
                [variant]="computedVariant"
                [content]="content()"
                [active]="true"
                [ensureHorizontalAlignment]="
                  listContainsHighlights() || listContainsIncentives()
                "
                [enableNewOfferCardTitles]="
                  !!content()?.enableNewOfferCardTitles
                "
                (selectOffer)="selectAndTrackOffer($any(matchingOffer))"
                (viewTariffs)="viewTariffs.emit($any(matchingOffer))"
                (openMoreInfo)="openMoreInfo.emit($any(matchingOffer))"
                [isQuestionnaireVariant]="true"
                [floatingIncentive]="true"
                (showQuestionnaireExplanation)="
                  showExplanation.emit(
                    getSpecificOfferValueFromOffer($any(matchingOffer))
                  )
                "
              />
            }
          </div>
        </div>
      }
      <div class="d-flex offer-list--vertical">
        @for (offer of remainingOffers(); track offer.offerId) {
          @if (offer.contractType === 'variable') {
            <wl-variable-offer-card
              [title]="content()?.questionnaireVariableCardTitle"
              [description]="content()?.questionnaireVariableCardDescription"
              [buttonTitle]="content()?.questionnaireVariableCardSubmitTitle"
              [explanationButtonTitle]="
                content()?.questionnaireExplanationButtonTitle
              "
              (showExplanation)="showExplanation.emit($event)"
              (selectOffer)="selectVariableOffer.emit()"
            />
          } @else {
            <essent-consumer-retention-minimal-commodity-offer
              [offer]="offer"
              [variant]="'accordion'"
              [content]="content()"
              [active]="false"
              [ensureHorizontalAlignment]="
                listContainsHighlights() || listContainsIncentives()
              "
              [enableNewOfferCardTitles]="!!content()?.enableNewOfferCardTitles"
              (selectOffer)="selectAndTrackOffer(offer)"
              (viewTariffs)="viewTariffs.emit(offer)"
              (openMoreInfo)="openMoreInfo.emit(offer)"
              [isQuestionnaireVariant]="true"
              [floatingIncentive]="true"
              (showQuestionnaireExplanation)="
                showExplanation.emit(getSpecificOfferValueFromOffer(offer))
              "
            />
          }
        }
      </div>
    } @else {
      @for (_ of [1, 2, 3]; track _) {
        <essent-consumer-retention-minimal-commodity-offer
          [showLoadingState]="true"
          [variant]="computedVariant"
          [active]="false"
          [enableNewOfferCardTitles]="!!content()?.enableNewOfferCardTitles"
        />
      }
    }
  }
</div>
